import { render, staticRenderFns } from "./EntrepotMobile.vue?vue&type=template&id=2c0c4309&scoped=true&"
import script from "./EntrepotMobile.vue?vue&type=script&lang=js&"
export * from "./EntrepotMobile.vue?vue&type=script&lang=js&"
import style0 from "./EntrepotMobile.vue?vue&type=style&index=0&id=2c0c4309&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c4309",
  null
  
)

export default component.exports